import SearchIcon from "@mui/icons-material/Search"
import { Box, Divider } from "@mui/material"
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation"
import React, { useEffect, useRef, useState } from "react"

import { DGText } from "../../components/common/DGText"
import { GenericButton } from "../../components/common/GenericButton"
import useTranslate from "../../hooks/use-translate"
import { appStore } from "../../store/AppStore"
import { comb } from "../../utilities/common"
import { s } from "../../utilities/common"
import { dimensions, platform, Platform } from "../../utilities/constants"
import { theme, TI } from "../../utilities/theme"
import { CuratedScreen } from "../Curated/CuratedScreen"
import { TabviewProps } from "../Curated/Tabview"

import { SearchPrompt } from "./Modals/SearchPrompt/SearchPrompt"
import { SearchScreenFocusKeys } from "./search-focus-keys"

export const SearchScreen = ({ slug, ...rest }: TabviewProps) => {
  const [searchOpen, setSearchOpen] = useState(false)
  const [visible, setVisible] = useState(false)
  const storeSlug = appStore((state) => state.slug)
  const t = useTranslate()
  useEffect(() => {
    setVisible(slug === storeSlug)
  }, [storeSlug])
  const { ref, focusKey } = useFocusable({
    focusable: visible,
    isFocusBoundary: true,
    focusBoundaryDirections: ["left", "down", "right"],
    preferredChildFocusKey: SearchScreenFocusKeys.SearchButton,
    saveLastFocusedChild: false,
  })

  const scrollRef = useRef(document.getElementById("root"))

  return (
    <FocusContext.Provider value={focusKey}>
      <Box
        ref={ref}
        sx={{
          display: "flex",
          width: "100%",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {platform !== Platform.Chromecast && (
          <>
            <GenericButton
              ariaLabel={"Search"}
              sx={{ mt: s("61px") }}
              onEnterPress={() => setSearchOpen(true)}
              focusKey={SearchScreenFocusKeys.SearchButton}
              scroll={{ scrollRef, offsetTop: dimensions.height / 2 }}
              prefScroll
            >
              <SearchIcon sx={{ width: s("36px"), height: s("36px") }} />
              <DGText tx={TI.Subheadline07tv}>{t("Search")}</DGText>
            </GenericButton>
            <Divider
              sx={{
                width: "80%",
                borderColor: theme.palette.white[30],
                mt: s("86px"),
                mb: s("88px"),
                pl: s("96px"),
                pr: s("96px"),
              }}
            />
          </>
        )}
        <CuratedScreen slug={slug} {...rest} />
      </Box>
      <SearchPrompt open={comb.ine(searchOpen, setSearchOpen)} />
    </FocusContext.Provider>
  )
}
